__turbopack_context__.v({
  "bottom_section": "Footer-module-sass-module__vRQyaG__bottom_section",
  "contact": "Footer-module-sass-module__vRQyaG__contact",
  "contact__title": "Footer-module-sass-module__vRQyaG__contact__title",
  "footer": "Footer-module-sass-module__vRQyaG__footer",
  "footer--contact": "Footer-module-sass-module__vRQyaG__footer--contact",
  "footer--homepage": "Footer-module-sass-module__vRQyaG__footer--homepage",
  "footer__content": "Footer-module-sass-module__vRQyaG__footer__content",
  "footer__wrapper": "Footer-module-sass-module__vRQyaG__footer__wrapper",
  "gax": "Footer-module-sass-module__vRQyaG__gax",
  "gradient_background": "Footer-module-sass-module__vRQyaG__gradient_background",
  "links": "Footer-module-sass-module__vRQyaG__links",
  "location": "Footer-module-sass-module__vRQyaG__location",
  "mentions": "Footer-module-sass-module__vRQyaG__mentions",
  "mentions__link": "Footer-module-sass-module__vRQyaG__mentions__link",
  "prefooter": "Footer-module-sass-module__vRQyaG__prefooter",
  "prefooter__cta": "Footer-module-sass-module__vRQyaG__prefooter__cta",
  "prefooter__title": "Footer-module-sass-module__vRQyaG__prefooter__title",
  "socials": "Footer-module-sass-module__vRQyaG__socials",
  "top_section": "Footer-module-sass-module__vRQyaG__top_section",
});
